import { useCallback } from "react";
import { useQuery } from "react-query";
import { IeLynxObject } from "../../common/models/eLynxObject";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { ISetPointViewModel } from "../../services/alarm-setpoints-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { selectAlarmSetpoints, UseAlarmSetpointsOptionsType, UseAlarmSetpointsReturnType } from "./Common";
import { keys } from "./Keys";

export type UseAlarmSetpointsParameters = {
    groupID: number,
    contextObject: IeLynxObject,
    options?: UseAlarmSetpointsOptionsType
} & BaseUseQueryParameters<UseAlarmSetpointsReturnType>;

export function useAlarmSetpoints({
    groupID,
    contextObject,
    options,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseAlarmSetpointsParameters) {
    return useQuery<Array<ISetPointViewModel>, RestError, UseAlarmSetpointsReturnType>(
        keys.list(groupID, contextObject),
        ({ signal }) => {
            return AlarmSetpointsDataService.getAlarmSetpointData(groupID, contextObject, signal);
        },
        {
            select: useCallback(
                (data: Array<ISetPointViewModel>) => selectAlarmSetpoints(data, options),
                [options]
            ),
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
        }
    );
}


